import { Component, Input } from '@angular/core';

@Component({
    selector: 'rank',
    styles: [`
         .rank-div {
            width:45px;
            padding-left: 1rem;
            line-height:30px;
        }
        
        .rank {
            display: inline-block;
            height: 19px;
            position: relative;
            vertical-align: middle;
            width: 19px;
        }
        .rank:before, .rank:after {
            background-repeat: no-repeat;
            bottom: 0;
            content: "";
            display: block;
            position: absolute;
            top: 0;
        }
        .rank:before {
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSI+PGcgZmlsbD0iI0Y4OEYxRSI+PGNpcmNsZSBjeD0iMi41IiBjeT0iMTYuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iOS41IiBjeT0iMTYuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2LjUiIHI9IjIuNSIvPjxjaXJjbGUgY3g9IjkuNSIgY3k9IjkuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjkuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjIuNSIgcj0iMi41Ii8+PC9nPjwvc3ZnPg==");
            background-position: left center;
            left: 0;
        }
        .rank:after {
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSI+PGcgZmlsbD0iI0JFQzhEMSI+PGNpcmNsZSBjeD0iMi41IiBjeT0iMTYuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iOS41IiBjeT0iMTYuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2LjUiIHI9IjIuNSIvPjxjaXJjbGUgY3g9IjkuNSIgY3k9IjkuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjkuNSIgcj0iMi41Ii8+PGNpcmNsZSBjeD0iMTYuNSIgY3k9IjIuNSIgcj0iMi41Ii8+PC9nPjwvc3ZnPg==");
            background-position: right center;
            right: 0;
            width: 100%;
        }
        .rank-1:before {
            width: 0%;
        }
        .rank-1:after {
            width: 100%;
        }
        .rank-2:before {
            width: 30%;
        }
        .rank-2:after {
            width: 70%;
        }
        .rank-3:before {
            width: 70%;
        }
        .rank-3:after {
            width: 30%;
        }
        .rank-4:before {
            width: 100%;
        }
        .rank-4:after {
            width: 0;
        }
        .rank-large {
            height: 44px;
            width: 44px;
        }
        
        .rank-large:before {
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCI+PGcgZmlsbD0iI0Y4OEYxRSI+PGNpcmNsZSBjeD0iNiIgY3k9IjM4IiByPSI2Ii8+PGNpcmNsZSBjeD0iMjIiIGN5PSIzOCIgcj0iNiIvPjxjaXJjbGUgY3g9IjM4IiBjeT0iMzgiIHI9IjYiLz48Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSI2Ii8+PGNpcmNsZSBjeD0iMzgiIGN5PSIyMiIgcj0iNiIvPjxjaXJjbGUgY3g9IjM4IiBjeT0iNiIgcj0iNiIvPjwvZz48L3N2Zz4=");
        }
        
        .rank-large:after {
            background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCI+PGcgZmlsbD0iI0JFQzhEMSI+PGNpcmNsZSBjeD0iNiIgY3k9IjM4IiByPSI2Ii8+PGNpcmNsZSBjeD0iMjIiIGN5PSIzOCIgcj0iNiIvPjxjaXJjbGUgY3g9IjM4IiBjeT0iMzgiIHI9IjYiLz48Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSI2Ii8+PGNpcmNsZSBjeD0iMzgiIGN5PSIyMiIgcj0iNiIvPjxjaXJjbGUgY3g9IjM4IiBjeT0iNiIgcj0iNiIvPjwvZz48L3N2Zz4=");
        }
       
    `],
    template: `
        <div [ngSwitch]="score">
            <div *ngSwitchCase="2" class="rank rank-large rank-2"></div>
            <div *ngSwitchCase="3" class="rank rank-large rank-3"></div>
            <div *ngSwitchCase="4" class="rank rank-large rank-4"></div>
            <div *ngSwitchDefault  class="rank rank-large rank-1"></div>
        </div>
    `
})
export class RankComponent {

    @Input() score: number = 0;
}
